var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C8.66667 24 5.83333 22.8333 3.5 20.5C1.16667 18.1667 0 15.3333 0 12C0 8.66667 1.16667 5.83333 3.5 3.5C5.83333 1.16667 8.66667 0 12 0C12.3111 0 12.6169 0.0111112 12.9173 0.0333335C13.2178 0.0555557 13.512 0.0888888 13.8 0.133333C12.8889 0.777778 12.1609 1.61689 11.616 2.65067C11.0711 3.68444 10.7991 4.80089 10.8 6C10.8 8 11.5 9.7 12.9 11.1C14.3 12.5 16 13.2 18 13.2C19.2222 13.2 20.3444 12.9276 21.3667 12.3827C22.3889 11.8378 23.2222 11.1102 23.8667 10.2C23.9111 10.4889 23.9444 10.7831 23.9667 11.0827C23.9889 11.3822 24 11.688 24 12C24 15.3333 22.8333 18.1667 20.5 20.5C18.1667 22.8333 15.3333 24 12 24Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.90077215cde2fc4c2421254c9160a96b.svg";
export { ForwardRef as ReactComponent };